import { Assets, Container, filters, MSAA_QUALITY, Renderer, RenderTexture, Sprite } from "pixi.js";
import { AtlasResource } from "../../ResourceManager/AtlasResource";
import { JSONResource } from "../../ResourceManager/JSONResource";
import { Resourceful, Resourceful2 } from "../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { LoadingStage, IWriteOnlyResourceManager, IReadOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import { Settings } from "../../Settings";
import { ISkeletonData, Spine } from "pixi-spine";
import { CreateElement, CreateSpineResources, Scale } from "../../MyHelpers";
import { ISystemContext } from "../../Context/SystemContext";
import { ITimeout } from "../../Context/Timeout";
import { IRandomInterval } from "../../Context/RandomInterval";
import { scale } from "svelte/transition";
import { PlaceHolderMutiPotConfig } from "./FillingPotGeneric";
import { AudioManager, Track } from "../../AudioManager";


export class LayoutPotElement implements Resourceful {
    readonly potName: string;
    readonly gameResourcesBasePath: string;
    readonly gameName: string;
    readonly systemContext: ISystemContext;
    protected jsonSpine: ISkeletonData = null;
    protected idleAnimInterval: IRandomInterval = null;
    protected audio : AudioManager = null;
    protected resid : ResourceIdentifier = null;
    constructor(potName: string, gameResourcesBasePath: string, gameName: string, systemContext: ISystemContext, audio : AudioManager , resid : ResourceIdentifier) {
        this.potName = potName;
        this.gameResourcesBasePath = gameResourcesBasePath;
        this.gameName = gameName;
        this.systemContext = systemContext;
        this.audio = audio;
        this.resid = resid?.Add(`${potName}`);
        
        if (this.systemContext) {

            this.idleAnimInterval = systemContext.TimingContext().CreateRandomInterval("idleAnimation", 3000, 10000, () => {
                if (this.layoutSpine?.state?.data?.skeletonData?.animations?.find(anim => anim.name == "idle")) {
                    this.layoutSpine?.state?.setAnimation(0, "idle", false);
                }
            })
        }
        //console.log("CreateLayout",potName);        
    }

    public PrepareResources(resourceManager: IWriteOnlyResourceManager) {
        //console.log("CreateLayout-Prepare",this.gameResourcesBasePath)                
        resourceManager.AddGlobal(new JSONResource(`${this.gameResourcesBasePath}FillingPotFeature/${Settings.Screens}Screens/LayoutPotElement/${this.potName}/${this.potName}.json`, ResourceIdentifier.Global.ScopedResourceName(`${this.gameName}-${this.potName}-LayoutPotElement-Json`)));
        resourceManager.AddGlobal(new AtlasResource(`${this.gameResourcesBasePath}FillingPotFeature/${Settings.Screens}Screens/LayoutPotElement/${this.potName}/${this.potName}.atlas`, ResourceIdentifier.Global.ScopedResourceName(`${this.gameName}-${this.potName}-LayoutPotElement-Atlas`)));
        
        // this.audio.AddTrack(new Track(`${this.gameResourcesBasePath}FillingPotFeature/${Settings.Screens}Screens/LayoutPotElement/${this.potName}/tracks/LayoutReelStop` + Settings.audioFormat, this.resid.ScopedResourceName("LayoutReelStop"),false));           
        // this.audio.AddTrack(new Track(`${this.gameResourcesBasePath}FillingPotFeature/${Settings.Screens}Screens/LayoutPotElement/${this.potName}/tracks/LayoutWin` + Settings.audioFormat, this.resid.ScopedResourceName("LayoutWin"),false));           
       
    }

    public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {
        let jsonResource = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(`${this.gameName}-${this.potName}-LayoutPotElement-Json`));
        let resource = await Assets.load(jsonResource.path);
        this.jsonSpine = resource.spineData;
        await this.ScreenshotLayout();
    }

    public layoutSpine: Spine = null;
    protected loopWin: boolean = false;
    public CreateElementIntoFillingPotSpine(spineContainer: Spine, placeHolderMutiPotConfig: PlaceHolderMutiPotConfig) {
        //if(this.layoutSpine != null) this.Destroy()
        this.loopWin = placeHolderMutiPotConfig.loopWin;
        this.layoutSpine = new Spine(this.jsonSpine);
        this.layoutSpine.name = this.potName;
        //spineContainer.addChild(this.layoutSpine);

        this.layoutSpine.state.addListener({
            complete: (entry) => {
                if (entry.animation.name == "win") this.idleAnimInterval.Restart();
            }
        })

        this.idleAnimInterval.Restart();

        (spineContainer.children as Container[]).forEach((container) => {
            if (container.name == `${this.potName}PlaceHolder`) {
                let bone = spineContainer.state.data.skeletonData.findBone(`${this.potName}PlaceHolder`);
                let scaleX = this.layoutSpine.scale.x + (1 - bone.parent.scaleX);
                let scaleY = (this.layoutSpine.scale.y) + (1 - bone.parent.scaleY);
                this.layoutSpine.scale.set(scaleX * placeHolderMutiPotConfig.scaleX, (scaleY * -1) * placeHolderMutiPotConfig.scaleY);
                container.addChild(this.layoutSpine);
                bone = null;
                scaleX = null;
                scaleY = null;
                this.layoutSpine.position.set(placeHolderMutiPotConfig.offsetX, placeHolderMutiPotConfig.offsetY);
            }
            container = null
        });
    }

    public CreateElementIntoContainer(container: Container, scale: number, indexPot: number , countElements : number) {
        this.layoutSpine = new Spine(this.jsonSpine);
        this.layoutSpine.scale.set(scale);
        this.layoutSpine.position.set(((Settings.ScreenWidth / countElements) * indexPot) - (this.layoutSpine.width / 2), 0);
        // this.layoutSpine.state.addListener({
        //     complete: (entry) => {
        //         if (entry.animation.name == "win" || entry.animation.name == "reelStop" ) this.idleAnimInterval.Restart();
        //     }
        // })

        //this.idleAnimInterval.Restart();
        container.addChild(this.layoutSpine);
        this.Disable();

        //this.ScreenshotLayout();
    }

    public Destroy() {
        this.idleAnimInterval.Stop();
        //this.layoutSpine.destroy();
        this.layoutSpine?.removeFromParent();
        this.layoutSpine = null;
    }

    public WinPot(loop: boolean = false) {
        this.idleAnimInterval.Stop();
        if (this.layoutSpine.state.data.skeletonData.animations.find(anim => anim.name == "win")) {
            //this.layoutSpine.state.clearTrack(0);
            this.layoutSpine.state.setAnimation(0, "win", loop);
            //this.layoutSpine.state.addAnimation(0, "win", loop, 1);
            this.audio.Play(this.resid.ScopedResourceName("LayoutWin"));
        }
    }

    public Enable() {
        // Disable a ColorMatrixFilter  for enable color      
        // Apply the filter to the Spine animation
        this.idleAnimInterval.Stop()
        //this.layoutSpine.filters = null;
        //this.WinPot(true);
        if (this.layoutSpine?.state?.data?.skeletonData?.animations?.find(anim => anim.name == "idle")) {
            this.layoutSpine?.state?.setAnimation(0, "idle", true);
        }
        this.layoutSpine.visible = true;
    }

    protected Disable() {
        // // Create a ColorMatrixFilter and set it to grayscale
        // let colorMatrix = new filters.ColorMatrixFilter();
        // colorMatrix.blackAndWhite(true); // Or you can use colorMatrix.desaturate();
        // // Apply the filter to the Spine animation
        // this.layoutSpine.filters = [colorMatrix];
        this.layoutSpine.visible = false ; 
    }


    protected screenShootLayout: HTMLImageElement = null;
    public async ScreenShootLayoutExternal(jsonSpine: ISkeletonData) {
        this.jsonSpine = jsonSpine;

        this.ScreenshotLayout();
    }
    protected ScreenshotLayout() {
        let spine = new Spine(this.jsonSpine);
        spine.cacheAsBitmap = true;
        spine.cacheAsBitmapMultisample = MSAA_QUALITY.HIGH;
        spine.cacheAsBitmapResolution = 2;

        //spine.width = this.spinnableReels.GetSymbolSize().width;
        //spine.height = this.spinnableReels.GetSymbolSize().height;
        spine.position.set(spine.width / 2, spine.height / 2);
        //spine.update(0);
        let renderTexture = RenderTexture.create({ width: spine.width, height: spine.height });
        // Render Spine object onto render texture
        let renderer = new Renderer({
            width: spine.width, height: spine.height, antialias: true
        });
        renderer.render(spine, { renderTexture: renderTexture });
        // Create a new Sprite using the RenderTexture                
        // Extract the canvas                
        //let canvas = renderer.plugins.extract.canvas(new PIXI.Sprite(renderTexture)) as HTMLCanvasElement;

        //let img = renderer.plugins.extract.img()
        // //create img div empty
        this.screenShootLayout = CreateElement("img", {
            style: {
                width: spine.width + "px",
                height: spine.height + "px",
                backgroundPosition: "center",
                backgroundSize: "contain",
                backgroundOrigin: "center",
            }
        });

        //add img src from data img saved 
        this.screenShootLayout.src = (renderer.plugins.extract.canvas(new Sprite(renderTexture)) as HTMLCanvasElement).toDataURL("image/png", 1);


        renderer.clear();
        renderer.destroy(true);
        renderTexture.destroy(true);
        //spine.autoUpdate = false;
        spine.destroy();
    }

    public GetScreenShotLayout() {
        return this.screenShootLayout;
    }

    public ReelStopAnim(){
        this.idleAnimInterval.Stop();
        if (this.layoutSpine?.state?.data?.skeletonData?.animations?.find(anim => anim.name == "reelStop")) {
            //this.layoutSpine.state.clearTrack(0);
            this.layoutSpine?.state?.setAnimation(0, "reelStop", false);
            this.audio.Play(this.resid.ScopedResourceName("LayoutReelStop"));
            //this.layoutSpine.state.addAnimation(0, "win", loop, 0);
        }
    }

    public SetMultiplier(numberMultiplier : number){    
        if(this.potName != "Multiplier") return   
        this.audio.Stop(this.resid.ScopedResourceName("LayoutWin")); 
        if (this.layoutSpine?.state?.data?.skeletonData?.animations?.find(anim => anim.name == `winX${numberMultiplier}`)) {
            this.layoutSpine.state.clearTrack(0);
            
            //this.layoutSpine?.state?.setAnimation(0, `winX${numberMultiplier}`, true);
            this.layoutSpine.state.addAnimation(0, `winX${numberMultiplier}`, true, 1);
        }
    }
}